import React from 'react';

const Radio = ({ name, label, className, onChange, id, checked, inpClass = "" }) => {
    return (
        <div className={className}>
            <input type="radio" name={name} value={label} className={inpClass} onChange={onChange} id={id} checked={checked} />
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

export default Radio;